import { useEffect, useState } from "react";
import { HiOutlineNewspaper } from "react-icons/hi";
import { toastErrorMessage } from "../../utils/toastMessage/toastMessage";
import { getNewsPublicService } from "../../services/userServices";
import PreLoader from "../PreLoader/PreLoader";

const NewsModal = ({ viewTag, onClose }) => {
  const [getNews, setGetNews] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleGetNews = async () => {
    try {
      const { status, data } = await getNewsPublicService();
      if (status === 200) {
        setGetNews(data);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.message);
        }
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await handleGetNews();
      setIsLoading(false);
    };
    fetchData();
  }, []);

  return (
    <div className={`relative ${viewTag === "pc" ? "w-full" : "w-[95%]"} mt-2`}>
      <div 
        className="text-black font-normal bg-white rounded-lg shadow-lg
        lg:h-64 h-44 overflow-y-auto p-4 text-justify text-sm border-2 border-yellow-300
        animate__animated animate__fadeInDown animate__fast"
      >
        {isLoading ? (
          <div className="flex justify-center items-center h-full">
            <PreLoader width={60} />
          </div>
        ) : (
          <>
            {getNews?.title === "" ? (
              <div className="w-full flex flex-col items-center justify-center h-full text-gray-500">
                <HiOutlineNewspaper size={40} />
                <span>خبری وجود ندارد</span>
              </div>
            ) : (
              <div className="animate__animated animate__fadeIn animate__slow">
                <div className="flex justify-between items-center mb-3">
                  <h3 className="text-lg font-bold text-yellow-600">
                    {getNews?.title}
                  </h3>
                  
                </div>
                <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                  {getNews?.description}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default NewsModal;